import React, { useState, useEffect } from "react";
import axios from "axios";
import style from "../../../css/admin/Workshopupload.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { API_BASE_URL } from "../../ApiConfig";
import { getSecureToken } from "../../ApisService/apiService";

const ViewWorkshops = () => {
  const [workshops, setWorkshops] = useState([]);
  const [expandedWorkshop, setExpandedWorkshop] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    fetchWorkshops();
  }, []);

 const fetchWorkshops = async () => {
          const { secrettoken, ts } = await getSecureToken();
  
  try {
    const response = await axios.get(`${API_BASE_URL}workshop_uploads/fetch_workshops.php`, {
               headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
      withCredentials: true,
    });
    setWorkshops(response.data);
  } catch (error) {
    console.error("Error fetching workshops:", error);
  }
};


  return (
    <div className={style.workshopContainer}>
      {workshops.length === 0 ? (
        <p className={style.workshopDescription}>No data available</p>
      ) : (
        workshops.map((workshop, index) => {
          const videoList = JSON.parse(workshop.video_path || "[]");
          const documentList = JSON.parse(workshop.document_path || "[]");

          return (
            <div key={index} className={style.workshopItem}>
              <div
                className={style.workshopTitle}
                onClick={() =>
                  setExpandedWorkshop(expandedWorkshop === index ? null : index)
                }
              >
                {workshop.title}
              </div>

              <AnimatePresence>
                {expandedWorkshop === index && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    className={style.workshopDetails}
                  >
                    {/* Conditionally show description */}
                    {workshop.description?.trim() && (
                      <p className={style.workshopDescription}>
                        {workshop.description}
                      </p>
                    )}

                    {/* Conditionally show videos */}
                    {videoList.length > 0 && (
                      <div className={style.videoGrid}>
                        {videoList.map((video, i) => (
                          <div
                            key={i}
                            className={style.videoThumbnail}
                            onClick={() =>
                              setSelectedVideo(
                                `${API_BASE_URL}workshop_uploads/workshop_uploads/videos/${video}`
                              )
                            }
                          >
                            <video className={style.videoPreview}>
                              <source
                                src={`${API_BASE_URL}workshop_uploads/workshop_uploads/videos/${video}`}
                                type="video/mp4"
                              />
                            </video>
                            <span className={style.playbuttons}>▶ Play Video</span>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Conditionally show documents */}
                    {documentList.length > 0 && (
                      <>
                        <h4 className={style.documenttext}>Documents:</h4>
                        <ul className={style.documentList}>
                          {documentList.map((doc, i) => (
                            <li key={i}>
                              <a
                                href={`${API_BASE_URL}workshop_uploads/workshop_uploads/documents/${doc}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={style.documentLink}
                              >
                                📄 {doc}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })
      )}

      {/* Video Modal */}
      {selectedVideo && (
        <div className={style.videoModal} onClick={() => setSelectedVideo(null)}>
          <div className={style.videoModalContent} onClick={(e) => e.stopPropagation()}>
            <video
              controls
              autoPlay
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
            >
              <source src={selectedVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button className={style.closeButton} onClick={() => setSelectedVideo(null)}>
              ✖ Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewWorkshops;
